export default "f79c723b3d0eb085.svg"